var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-history" },
    [
      _vm.validatedTrades.length
        ? [
            _c("div", { staticClass: "text_large" }, [
              _vm._v(_vm._s(_vm.i18n.trd_history()))
            ]),
            _vm._v(" "),
            _c(
              "md-table",
              { staticClass: "trade-history__table scrollbar" },
              [
                _c(
                  "md-table-row",
                  [
                    _c("md-table-head", [
                      _vm._v(
                        _vm._s(
                          _vm.i18n.trd_history_amount({
                            asset: _vm.assets.base
                          })
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(
                        _vm._s(
                          _vm.i18n.trd_history_price({
                            asset: _vm.assets.quote
                          })
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(
                        _vm._s(
                          _vm.i18n.trd_history_total({
                            asset: _vm.assets.quote
                          })
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.trd_history_time()))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.validatedTrades, function(item, i) {
                  return _c(
                    "md-table-row",
                    {
                      key: i + "-trade-history-item",
                      class: "trade-history__item-status--" + item.priceStatus
                    },
                    [
                      i < _vm.maxLengthOfTradeHistory
                        ? [
                            _c("md-table-cell", { staticClass: "text_large" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.roundCurrency(
                                    item.baseAmount,
                                    _vm.assets.base
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              {
                                staticClass:
                                  "trade-history__item-price text_large"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.roundCurrency(
                                        item.price,
                                        _vm.assets.quote
                                      )
                                    ) +
                                    "\n            "
                                ),
                                item.priceStatus === 0
                                  ? [_c("md-icon", [_vm._v("call_received")])]
                                  : _vm._e(),
                                _vm._v(" "),
                                item.priceStatus === 1
                                  ? [_c("md-icon", [_vm._v("call_made")])]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              {
                                staticClass:
                                  "trade-history__item-total text_large"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.roundCurrency(
                                      _vm.multiply(item.baseAmount, item.price),
                                      _vm.assets.quote
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-table-cell",
                              {
                                staticClass:
                                  "trade-history__item-date text_large"
                              },
                              [_vm._v(_vm._s(_vm.toValidDate(item.createdAt)))]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                })
              ],
              2
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "container__no-data" },
              [
                _c("md-icon", { staticClass: "md-size-4x" }, [
                  _vm._v("trending_up")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text_large" }, [
                  _vm._v(_vm._s(_vm.i18n.trd_no_trade_history()))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_description text_margin text_medium" },
                  [_vm._v(_vm._s(_vm.i18n.trd_here_will_be_the_list()))]
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ffdd5d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ffdd5d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/components/tradeHistory/Trade.TradeHistory.vue
// module id = 22eU
// module chunks = 1